import { render } from "./LgpdMessage.vue?vue&type=template&id=46b33c2d&scoped=true"
import script from "./LgpdMessage.vue?vue&type=script&lang=js"
export * from "./LgpdMessage.vue?vue&type=script&lang=js"

import "./LgpdMessage.vue?vue&type=style&index=0&id=46b33c2d&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/uparte_dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b33c2d"]])

export default __exports__